import React from 'react';
export interface DefinitionItem {
  term: string;
  value: React.ReactNode;
}

/**
 * Term and value pairs, so a `dl` rather than a grid of divs.
 *
 * Two columns from `sm`, with the term in the narrower one: these are
 * looked up rather than read through, so the labels want to line up.
 */
export function DefinitionList({
  items
}: {
  items: DefinitionItem[];
}) {
  return <dl data-component-id="C37" className="divide-y divide-hairline border-y border-hairline" data-id="element-417" data-mp="2q3peg3ipx5s2">
      {items.map(item => <div key={item.term} className="grid gap-1 py-4 sm:grid-cols-[14rem_1fr] sm:gap-6" data-id="element-418" data-mp="2l5w7375oi5q7">
          <dt className="text-sm font-bold uppercase tracking-[0.08em] text-ink-muted" data-id="element-419" data-mp="2yxat7muvun1h">
            {item.term}
          </dt>
          <dd className="leading-relaxed text-ink" data-id="element-420" data-mp="26fozjmh7m74a">{item.value}</dd>
        </div>)}
    </dl>;
}